/* istanbul ignore file */

/**
 * Should have all locale keys used in this project with translations matching the language-region
 * code of this file.
 */
export default {
  schedulerReact: {
    startDate: 'Start Date',
    endDate: 'End Date',
    ends: 'Ends',
    never: 'Never',
    afterXOccurences: 'After {0} occurrences',
    endSelected: 'End by selected date',
    repeat: 'Repeat',
    every: 'Every',
    onThe: 'On the',
    on: 'On',
    atTime: 'At Time',
    addAnother: 'Add Another',
    forExample: 'For Example: {0}',
    minutes: 'Minutes',
    hourly: 'Hourly',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    semimonthly: 'Semi-Monthly',
    yearly: 'Yearly',
    jan: 'January',
    feb: 'February',
    mar: 'March',
    apr: 'April',
    may: 'May',
    jun: 'June',
    jul: 'July',
    aug: 'August',
    sep: 'September',
    oct: 'October',
    nov: 'November',
    dec: 'December',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    first: 'First',
    second: 'Second',
    third: 'Third',
    fourth: 'Fourth',
    last: 'Last',
    everyXMinutes: 'Every {0} minute(s)',
    everyXHours: 'Every {0} hour(s)',
    everyXWeeks: 'Every {0} week(s)',
    everyXMonths: 'Every {0} month(s)',
    everyXYears: 'Every {0} year(s)',
    weeklyMin: 'Select at least {0} day(s)',
    thu: 'Th',
    mon: 'M',
    tue: 'T',
    wed: 'W',
    fri: 'F',
    sat: 'S',
    sun: 'S',
    day: 'Day',
    remove: 'Remove'
  }
};
